import { pipe, get } from 'lodash/fp'

const hasCredits = pipe(get('credits.value'), Boolean)

const hasFinalPrice = pipe(get('finalPrice.value'), value => !value)

const isAllCredits = order => hasCredits(order) && hasFinalPrice(order)

export default isAllCredits
